import { tw } from 'utils/classnames'

import { transformImage } from '../utils/image'

interface Props {
  className?: string
  wrapperClassName?: string
  backgroundImage?: string
  backgroundColor?: string
  textColor?: string
}
export function BannerContainer({
  backgroundImage,
  backgroundColor,
  textColor,
  children,
  className,
  wrapperClassName,
}: React.PropsWithChildren<Props>) {
  const style = {
    backgroundColor,
    color: textColor,
  }
  return (
    <>
      <div
        className={tw(
          'relative flex flex-col justify-between gap-5 overflow-hidden bg-cover bg-no-repeat text-[14px]',
          className,
        )}
        style={style}
      >
        {backgroundImage ? (
          <picture className="absolute inset-0">
            <source
              media="(min-width: 768px)"
              srcSet={transformImage(backgroundImage).desktop}
              type="image/webp"
            />
            <source
              media="(max-width: 767px)"
              srcSet={transformImage(backgroundImage).mobile}
              type="image/webp"
            />
            <img
              src={transformImage(backgroundImage).mobile}
              alt="banner background"
              className="absolute h-full w-full object-cover object-left"
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />
          </picture>
        ) : null}
        <div
          className={tw(
            'isolate m-auto flex w-full items-center justify-center p-[10px] md:w-auto md:justify-between xl:mx-[8.33%]',
            wrapperClassName,
          )}
        >
          {children}
        </div>
      </div>
    </>
  )
}
